export function historyComment(row = {}, linked = {}) {
  const fields = value => [value.comment, value.notes, value.description, value.detail, value.details?.notes, value.details?.comment, value.data?.notes, value.data?.comment];
  return [...new Set([...fields(row), ...fields(linked)].filter(value => typeof value === 'string').map(value=>value.trim()).filter(value=>value && value !== row.title && value !== row.label))].join('\n\n');
}
